import React from "react";
import { useNavigate } from "react-router-dom";
import userProfile from "../../../assets/images/user-profile.svg";
import wallet from "../../../assets/images/wallet.svg";
import useStore from "../../../store/useStore";
import { getDecodedToken } from "../../../utils/localStorage";
import { trackZymedEvent, ZYMED_EVENTS } from "../../../utils/zymedAnalytics";

interface HeaderProps {
  isRemoteCare?: boolean;
}

const Header: React.FC<HeaderProps> = ({ isRemoteCare = false }) => {
  const navigate = useNavigate();
  const { planDetails } = useStore();
  const tokenData: any = getDecodedToken();
  const doctorDetails: any = tokenData?.user || {};

  const walletHandler = () => {
    navigate("/rewards");
  };

  const profileHandler = () => {
    trackZymedEvent(ZYMED_EVENTS.HOME_PROFILE_ICON_CLICKED);
    navigate("/account");
  };
  return (
    <header className="flex overflow-hidden flex-col w-full">
      <nav className="flex overflow-hidden justify-between gap-10 items-center px-6 py-2 w-full">
        <div className="left-0 gap-3 w-auto my-auto text-xl font-medium">
          <h3>Hi, Dr. {doctorDetails?.name.split(" ")[1]} 👋</h3>
        </div>
        <div className="flex gap-3 items-center justify-end self-stretch my-auto w-[92px]">
          {/* {planDetails?.remote_plan && isRemoteCare && (
            <div className="w-[40px] h-[40px] p-[8px] rounded-[28px] bg-[#5251D714] shadow-[0px_0px_12px_0px_#00000008]">
              <img
                loading="lazy"
                src={wallet}
                onClick={walletHandler}
                alt="Wallet"
                className="object-contain shrink-0 self-stretch my-auto rounded-3xl aspect-square shadow-[0px_0px_12px_rgba(0,0,0,0.03)] w-[24px] h-[24px] top-[8px] left-[8px]"
              />
            </div>
          )} */}
          {!isRemoteCare && (
            <div className="w-[40px] h-[40px] p-[8px] rounded-[28px] bg-[#5251D714] shadow-[0px_0px_12px_0px_#00000008]">
              <img
                loading="lazy"
                src={userProfile}
                alt="Profile"
                className="object-contain shrink-0 self-stretch my-auto rounded-3xl aspect-square shadow-[0px_0px_12px_rgba(0,0,0,0.03)] w-[24px] h-[24px] top-[8px] left-[8px]"
                onClick={profileHandler}
              />
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;
